import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdown from "./DropPartMarkdown";
import DropListItemContentMedia from "../item/content/media/DropListItemContentMedia";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { MentionedWave } from "@/entities/IDrop";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
interface DropPartContentProps {
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly mentionedWaves: MentionedWave[];
  readonly referencedNfts: ApiDropReferencedNFT[];
  readonly partContent: string | null;
  readonly onQuoteClick: (drop: any) => void;
  readonly currentDropId?: string | undefined;
  readonly partMedias: Array<{
    mimeType: string;
    mediaSrc: string;
  }>;
  readonly currentPartCount: number;
}
const DropPartContent: React.FC<DropPartContentProps> = t0 => {
  const $ = _c(14);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    partContent,
    onQuoteClick,
    currentDropId,
    partMedias,
    currentPartCount
  } = t0;
  let t1;
  if ($[0] !== currentDropId || $[1] !== mentionedUsers || $[2] !== mentionedWaves || $[3] !== onQuoteClick || $[4] !== partContent || $[5] !== referencedNfts) {
    t1 = <div className="tw-group"><DropPartMarkdown mentionedUsers={mentionedUsers} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={partContent} onQuoteClick={onQuoteClick} currentDropId={currentDropId} /></div>;
    $[0] = currentDropId;
    $[1] = mentionedUsers;
    $[2] = mentionedWaves;
    $[3] = onQuoteClick;
    $[4] = partContent;
    $[5] = referencedNfts;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== currentPartCount || $[8] !== partContent || $[9] !== partMedias) {
    t2 = !!partMedias.length && <div className={`${partContent ? "tw-mt-4" : "tw-mt-1"} tw-space-y-2`}>{partMedias.map((media, i) => <div key={`part-${currentPartCount}-media-${i}-${media.mediaSrc}`} className="tw-h-64"><DropListItemContentMedia media_mime_type={media.mimeType} media_url={media.mediaSrc} /></div>)}</div>;
    $[7] = currentPartCount;
    $[8] = partContent;
    $[9] = partMedias;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <div className="tw-h-full tw-w-full">{t1}{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export default DropPartContent;